// extracted by mini-css-extract-plugin
export default {"prevArrow":"charity_page2_prevArrow__5IJ5Z","nextArrow":"charity_page2_nextArrow__b3Khn"};